$(document).on('click', '.js-mobileToggle', function() {
  const _this = $(this);

  if (_this.next().length > 0 && window.innerWidth < 768) {
  	_this.parent().toggleClass('is_active');
  	_this.next().slideToggle(200);
  }
});